import { useMutation } from '@apollo/client/react';
import type { AnonymousUser } from '@blinq-types';
import { UpdateUserDocDocument } from '@graphql/mutations/user/update-user-doc.graphql';
import { useFeatureFlag } from '@modules/feature-flag';
import { cacheUser, fetchGclidAndFbclid, oldUpdateUser } from '@modules/user-doc-helpers';

export const useUpdateUserDoc = () => {
  const [update, { loading: loadingUpdate }] = useMutation(UpdateUserDocDocument);
  const [useGraphQl, { loading: loadingUseGraphQl }] = useFeatureFlag(
    'schrodinger_create_update_user_doc',
    'off',
  );

  const updateUserDoc = async (input: AnonymousUser, cache = true) => {
    // this was saved earlier in the user create flow
    // update it here just in case
    const { gclid, fbclid } = fetchGclidAndFbclid(input.userId);
    if (gclid) {
      input.gclid = gclid;
    }

    if (fbclid) {
      input.fbclid = fbclid;
    }

    if (cache) cacheUser(input);

    await update({
      variables: {
        input: {
          data: {
            ...input,
          },
        },
      },
    });
  };

  return {
    updateUserDoc: useGraphQl === 'on' ? updateUserDoc : oldUpdateUser,
    loading: loadingUpdate || loadingUseGraphQl,
  };
};
